'use client';

import { type ReactElement } from 'react';
import { cn } from '@fshr/shared-react';
import BevSafeText from '../bev-safe-text';
import Icon from '../icon';
import type { LocationTileData } from './types';

const VALUE_CLASS = 'text-body2 text-text-primary';
const LINK_CLASS =
	'underline decoration-solid [text-decoration-skip-ink:none] [text-underline-position:from-font] focus-visible:outline-2 focus-visible:outline-offset-2';

type Props = {
	tile: LocationTileData;
	isFirst: boolean;
	dividerPaddingClass: string;
};

export default function LocationTile({ tile, isFirst, dividerPaddingClass }: Props): ReactElement {
	return (
		<li
			className={cn(
				'min-w-0 md:flex-1',
				!isFirst && `md:border-l md:border-border-subtle ${dividerPaddingClass}`
			)}
		>
			<div className="flex gap-stack-s md:flex-col md:gap-stack-2xs">
				{tile.icon && (
					<Icon
						icon={tile.icon}
						className="self-start block h-auto shrink-0 text-[28px] text-text-heading md:text-[32px]"
					/>
				)}

				<div className="flex min-w-0 flex-1 flex-col gap-y-stack-2xs">
					{tile.title && (
						<p className="text-subtitle2 line-clamp-2 text-text-heading">
							<BevSafeText>{tile.title}</BevSafeText>
						</p>
					)}

					{tile.href ? (
						<a
							href={tile.href}
							target={tile.newWindow ? '_blank' : undefined}
							rel={tile.newWindow ? 'noopener' : undefined}
							className={`${VALUE_CLASS} ${LINK_CLASS}`}
						>
							<BevSafeText>{tile.description}</BevSafeText>
						</a>
					) : (
						<p className={VALUE_CLASS}>
							<BevSafeText>{tile.description}</BevSafeText>
						</p>
					)}
				</div>
			</div>
		</li>
	);
}
